import { Row, Col } from "reactstrap";
import { NakedTable } from "components";

const previousLessonRecordsColumn = [
	{
		id: "lessonName",
		header: "Lesson Name",
		accessor: (row) => row.lesson?.name,
	},
];

const PreviousLessonRecords = ({ student }) => {
	return (
		<Row>
			<Col sm="12">
				<NakedTable data={student?.legacyCompletedLessonRecords} columns={previousLessonRecordsColumn} defaultPageSize={100} loading={!Boolean(student)} marginClass="mt-2" />
			</Col>
		</Row>
	);
};

export default PreviousLessonRecords;
